module.exports = __webpack_public_path__ + "static/media/jenkins.8f85758f.png";